/**
 * Created by svitlana.i on 9/21/2017.
 */

declare var $: any;

export class Select2Util {
    public static checkIfSelectOpen(id: string): boolean {
        return $('#' + id + ' .select2-container--open').length > 0;

    }
}


// WEBPACK FOOTER //
// ./app/common/utils/select2Util.ts